import {IUserRepository} from './IUserRepository';
import {updateUser, adminCreateCognitoUser} from './UserMutation';
import {UserUpdate} from '../../graphql/API';
import {generateClient, GraphQLResult} from 'aws-amplify/api';
const client = generateClient();
export class UserRepository implements IUserRepository {
  async updateUser(
    userId: string,
    updatedAt: string,
    user: UserUpdate,
  ): Promise<any> {
    try {
      const response: GraphQLResult<any> = await client.graphql({
        query: updateUser,
        variables: {
          id: userId,
          updatedAt: updatedAt,
          input: user,
        },
      });

      return response;
    } catch (error) {
      console.log('update user Error: ', error);
      throw new Error(error);
    }
  }
  async createUser(
    cognitoUserId: string,
    country: string,
    whatsappNumber: string,
  ): Promise<any> {
    const createUserCustom = `mutation CreateUser($input: UserInsert!) {
          createUser(input: $input) {
            id
            createdAt
          }
        }
        `;
    let response: GraphQLResult<any> = await client.graphql({
      query: createUserCustom,
      variables: {
        input: {
          cognitoUserId: cognitoUserId,
          country: country,
          whatsappNumber: whatsappNumber,
        },
      },
    });

    return response;
  }
  async adminCreateCognitoUser(
    phoneNumber: string,
    email: string,
    password: string,
  ): Promise<any> {
    let response: GraphQLResult<any> = await client.graphql({
      query: adminCreateCognitoUser,
      variables: {
        phoneNumber,
        email,
        password,
      },
    });
    return response;
  }
}
